"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = exports.create = exports.fetchAll = exports.fetch = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const serviceFloorService_1 = require("./service/serviceFloorService");
const Env_1 = require("../../utils/tsUtils/Env");
exports.fetch = (0, toolkit_1.createAsyncThunk)('serviceFloor/fetch', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const serviceFloorService = new serviceFloorService_1.ServiceFloorService(Env_1.APIPATHENV);
        const response = yield serviceFloorService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in fetching service floor data");
    }
}));
exports.fetchAll = (0, toolkit_1.createAsyncThunk)('serviceFloor/fetchAll', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const serviceFloorService = new serviceFloorService_1.ServiceFloorService(Env_1.APIPATHENV);
        const response = yield serviceFloorService.fetch(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in fetching service floor data");
    }
}));
exports.create = (0, toolkit_1.createAsyncThunk)('serviceFloor/create', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const serviceFloorService = new serviceFloorService_1.ServiceFloorService(Env_1.APIPATHENV);
        const response = yield serviceFloorService.create(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in creating service floor data");
    }
}));
exports.update = (0, toolkit_1.createAsyncThunk)('serviceFloor/update', (payload, thunkAPI) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const serviceFloorService = new serviceFloorService_1.ServiceFloorService(Env_1.APIPATHENV);
        const response = yield serviceFloorService.update(payload);
        return response;
    }
    catch (error) {
        throw new Error("Error in updating service floor data");
    }
}));
